import instance from "..";

interface AggregateIRAActivityResponseItem {
  account_id: string;
  tax_year: string;
  total_contribution: string;
}

export interface AggregateIRAActivityResponse
  extends Array<AggregateIRAActivityResponseItem> {}

export const getAggregateIRAActivity = async () => {
  const res = await instance.get<AggregateIRAActivityResponse>(
    `/ira/contributions/activity`,
  );

  return res.data;
};

export interface IRALimitsResponse {
  tax_year: string;
  regular_amount: string;
  catchup_amount: string;
}

export const getIRALimits = async (taxYear: string) => {
  const res = await instance.get<IRALimitsResponse>(
    `/ira/contributions/limits/${taxYear}`,
  );

  return res.data;
};
